import 'css-chunksrc/client/common/filterMenu/input/styles.scss';export default {
  "input": "_input_1437k_1",
  "opened": "_opened_1437k_20",
  "toggleIcon": "_toggleIcon_1437k_25",
  "placeholder": "_placeholder_1437k_39",
  "folder": "_folder_1437k_46",
  "icon": "_icon_1437k_58",
  "tagIcon": "_tagIcon_1437k_70"
};